import React from "react";

const EmptyJobsState = ({ title, description }) => {
  return (
    <div
      className="text-center py-5 px-4"
      style={{
        background: "#f8fafb",
        borderRadius: "12px",
        border: "1px dashed #d0d7de",
      }}
    >
      <h6
        className="mb-2"
        style={{ color: "#2D3E4D", fontWeight: 600, fontSize: "18px" }}
      >
        {title || "No jobs yet"}
      </h6>
      <p
        className="mb-4 mx-auto"
        style={{ color: "#556571", maxWidth: "420px", lineHeight: 1.6 }}
      >
        {description ||
          "Create your first job to start using AI outreach, intake questions, interview prep, and more."}
      </p>
      <button
        type="button"
        className="__btn"
        data-bs-toggle="modal"
        data-bs-target="#create-new-job-popup"
      >
        Create Your First Job
      </button>
    </div>
  );
};

export default EmptyJobsState;
